export default "__VITE_ASSET__WONUWSWZ__"